/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { GroundingMenuItemState, GroundingMenuItemSlots } from './GroundingMenuItem.types';

/**
 * Render the final JSX of GroundingMenuItem
 */
export const renderGroundingMenuItem_unstable = (state: GroundingMenuItemState): JSXElement => {
  assertSlots<GroundingMenuItemSlots>(state);

  return (
    <state.root>
      <state.persona />
      {state.submenuButton &&
        (state.submenuButtonTooltip ? (
          <state.submenuButtonTooltip>
            <state.submenuButton />
          </state.submenuButtonTooltip>
        ) : (
          <state.submenuButton />
        ))}
    </state.root>
  );
};
